import { type FunctionComponent } from 'react';
import { ReactComponent as RedStripGenericSVG } from '../../assets/icons/mevo/medicine/tarjavermelha_generico.svg';
import IconPattern, { IconProps } from './_IconPattern';

const MedicineRedStripGenericIcon: FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={RedStripGenericSVG} variantPlaces={[]} {...props} />;
};

export default MedicineRedStripGenericIcon;
